/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1PaymentsKind } from './V1PaymentsKind'
import {
    V1PaymentsKindFromJSON,
    V1PaymentsKindFromJSONTyped,
    V1PaymentsKindToJSON,
    V1PaymentsKindToJSONTyped
} from './V1PaymentsKind'
import type { V1PaymentAassetKind } from './V1PaymentAassetKind'
import {
    V1PaymentAassetKindFromJSON,
    V1PaymentAassetKindFromJSONTyped,
    V1PaymentAassetKindToJSON,
    V1PaymentAassetKindToJSONTyped
} from './V1PaymentAassetKind'

/**
 *
 * @export
 * @interface V1PaymentsInitRequest
 */
export interface V1PaymentsInitRequest {
    /**
     *
     */
    kind: V1PaymentsKind
    /**
     *
     */
    assetKind: V1PaymentAassetKind
    /**
     *
     */
    assetId: string
}

/**
 * Check if a given object implements the V1PaymentsInitRequest interface.
 */
export function instanceOfV1PaymentsInitRequest(
    value: object
): value is V1PaymentsInitRequest {
    if (!('kind' in value) || value['kind'] === undefined) return false
    if (!('assetKind' in value) || value['assetKind'] === undefined)
        return false
    if (!('assetId' in value) || value['assetId'] === undefined) return false
    return true
}

export function V1PaymentsInitRequestFromJSON(
    json: any
): V1PaymentsInitRequest {
    return V1PaymentsInitRequestFromJSONTyped(json, false)
}

export function V1PaymentsInitRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1PaymentsInitRequest {
    if (json == null) {
        return json
    }
    return {
        kind: V1PaymentsKindFromJSON(json['kind']),
        assetKind: V1PaymentAassetKindFromJSON(json['assetKind']),
        assetId: json['assetId']
    }
}

export function V1PaymentsInitRequestToJSON(json: any): V1PaymentsInitRequest {
    return V1PaymentsInitRequestToJSONTyped(json, false)
}

export function V1PaymentsInitRequestToJSONTyped(
    value?: V1PaymentsInitRequest | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        kind: V1PaymentsKindToJSON(value['kind']),
        assetKind: V1PaymentAassetKindToJSON(value['assetKind']),
        assetId: value['assetId']
    }
}
